import { FC } from 'react';
import styles from './style.module.css';
import {
  Switch,
  Title,
  Option,
  Autocomplete,
  AccordionTrigger,
  AccordionContent,
  AccordionTitle,
} from '@plataformaxvia/design-system';

export interface DepartmentSectionsFilterProps {
  isMobile: boolean;
  isFilterOpen: boolean;
  setIsFilterOpen: (open: boolean) => void;
  city: Option | null;
  setCity: (option: Option | null) => void;
  citySections: Option[];
  isOpenCity: boolean;
  setIsOpenCity: (isOpen: boolean) => void;
  searchQueryCity: string;
  setSearchQueryCity: (query: string) => void;
  expressoOnly: boolean;
  onExpressoOnlyChange: (checked: boolean) => void;
}

export const DepartmentSectionsFilter: FC<DepartmentSectionsFilterProps> = ({
  isMobile,
  isFilterOpen,
  setIsFilterOpen,
  city,
  setCity,
  citySections,
  isOpenCity,
  expressoOnly,
  setIsOpenCity,
  searchQueryCity,
  setSearchQueryCity,
  onExpressoOnlyChange,
}) => (
  <div className={styles.wrap}>
    {isMobile ? (
      <>
        <AccordionTrigger
          onToggle={() => setIsFilterOpen(!isFilterOpen)}
          active={isFilterOpen}
        >
          <AccordionTitle marker>
            Filtro de Atendimento Presencial
          </AccordionTitle>
        </AccordionTrigger>

        <AccordionContent active={isFilterOpen} divider={false}>
          <CardContent
            isMobile={isMobile}
            isOpenCity={isOpenCity}
            city={city}
            setCity={setCity}
            citySections={citySections}
            setIsOpenCity={setIsOpenCity}
            searchQueryCity={searchQueryCity}
            setSearchQueryCity={setSearchQueryCity}
          />
        </AccordionContent>
      </>
    ) : (
      <>
        <Title title="Filtro de Atendimento Presencial" as="h2" />
        <CardContent
          isMobile={isMobile}
          isOpenCity={isOpenCity}
          city={city}
          setCity={setCity}
          citySections={citySections}
          setIsOpenCity={setIsOpenCity}
          searchQueryCity={searchQueryCity}
          setSearchQueryCity={setSearchQueryCity}
        />
      </>
    )}

    <div className={styles.divider} />

    <span className={styles.formaRealizacaoLabel}>Forma de realização</span>

    <label htmlFor="expresso-cidadao-filter" className={styles.expressoLabel}>
      <Switch
        id="expresso-cidadao-filter"
        checked={expressoOnly}
        setChecked={onExpressoOnlyChange}
      />
      Expresso Cidadão
    </label>
  </div>
);

interface CardContentProps {
  isMobile: boolean;
  isOpenCity: boolean;
  city: Option | null;
  setCity: (option: Option | null) => void;
  citySections: Option[];
  setIsOpenCity: (value: boolean) => void;
  searchQueryCity: string;
  setSearchQueryCity: (value: string) => void;
}

const CardContent: FC<CardContentProps> = ({
  isMobile,
  isOpenCity,
  city,
  setCity,
  citySections,
  setIsOpenCity,
  searchQueryCity,
  setSearchQueryCity,
}) => (
  <div className={styles.cardBaseLocation}>
    <div
      className={`${styles.baseLocation}${
        isMobile && isOpenCity ? ` ${styles.baseLocationOpen}` : ''
      }`}
    >
      <Title title="Buscar local de atendimento" as="h3" />

      <Autocomplete
        label="Selecione o município"
        value={city}
        setValue={setCity}
        options={citySections}
        isOpen={isOpenCity}
        setIsOpen={setIsOpenCity}
        searchQuery={searchQueryCity}
        setSearchQuery={setSearchQueryCity}
      />
    </div>
  </div>
);
